import Vue from 'vue';
import VueGtag from 'vue-gtag';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Nl2br from 'vue-nl2br';
import App from '@/App';
import router from '@/router';
import store from '@/store/index';
import vuetify from '@/plugins/vuetify';

Vue.component('nl2br', Nl2br);

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  });
}

Vue.config.productionTip = false;

if (process.env.VUE_APP_GA_ID) {
  Vue.use(
    VueGtag,
    {
      config: { id: process.env.VUE_APP_GA_ID },
    },
    router
  );
}

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
